(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeActiveHeatmap', PropriedadeActiveHeatmap);

  PropriedadeActiveHeatmap.$inject = [
    '$route',
    '$routeParams'
  ];

  function PropriedadeActiveHeatmap($route) {
    return {
      restrict: 'E',
      templateUrl: 'views/propriedade/propriedade-active-heatmap.html',
      scope: {
        maps: '<',
        mapType: '<'
      },
      link(scope) {
        scope.clearHeatMap = function clearHeatMap() {
          scope.$emit('setImageOverlays', []);
          scope.$emit('setActiveHeatmaps', []);
          scope.$emit('clearPolylines');
          scope.$emit('clearMarkers');
          $route.updateParams({
            heatmaps: null
          });
        };
      }
    };
  }
}());
